import * as React from 'react';
import { useEffect, useState } from 'react';
import { Create, SimpleForm, TextInput, DateInput, required, SelectInput, ImageInput, ImageField, FileInput, BooleanInput, RadioButtonGroupInput, useDataProvider, TopToolbar } from 'react-admin';
import BackButton from '../../Components/BackButton';

// 添加电话号码校验
const validatePhone = (value: string) => {
    const phoneRegex = /^1[3-9]\d{9}$/;
    if (!phoneRegex.test(value)) {
        return '请输入有效的手机号码';
    }
    return undefined;
};

// 将文件转换为Base64格式的辅助函数
const toBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = error => reject(error);
    });
};

const ActionsToolbar = () => (
    <TopToolbar sx={{ justifyContent: 'start' }}>
        <BackButton />
    </TopToolbar>
);


export const TrafficAccountCreate = () => {
    const dataProvider = useDataProvider(); // 获取dataProvider
    const [customerTypeChoices, setCustomerTypeChoices] = useState([]);

    const [logoBase64, setLogoBase64] = useState<string | null>(null);

    useEffect(() => {
        // 异步获取客户类型数据
        const fetchCustomerTypes = async () => {
            try {
                const types = await dataProvider.getCustomerTypes();
                setCustomerTypeChoices(types);
            } catch (error) {
                console.error("获取客户类型失败:", error);
            }
        };

        fetchCustomerTypes();
    }, []);  // 空依赖数组确保只调用一次


    // 处理LOGO上传的函数
    const handleLogoUpload = async (file: File) => {
        try {
            const base64 = await toBase64(file);
            setLogoBase64(base64);
            return base64;
        } catch (error) {
            console.error("LOGO转换失败:", error);
            return null;
        }
    };

    // 在提交前将Base64格式的LOGO添加到表单数据中
    const transformData = (data: any) => {
        return {
            ...data,
            logo: logoBase64
        };
    };


    return (<Create actions={<ActionsToolbar />} transform={transformData}>
        <SimpleForm sx={{ width: { lg: '40%', xs: '100%' } }} defaultValues={{ customerType: '2' }}>
            <TextInput label="客户名称" source="name" validate={[required()]} />
            <SelectInput
                alwaysOn
                source="customerTypeId"
                label="客户类型"
                choices={customerTypeChoices}
            />
            <TextInput label="负责人" source="manager" validate={[required()]} />
            <TextInput label="联系电话" source="contactPhone" validate={[required(), validatePhone]} />
            <TextInput label="流量SN生成规则" source="snRule" />
            <DateInput
                label="合同结束日期"
                source="contractEndDate"
                validate={[required()]}
            />
            {/* <TextInput label="分成占比" source="revenueShare" disabled /> */}
        </SimpleForm>
    </Create>
    )
};